import { iconSet } from './IconLibrary';

export const IconNames: string[] = Object.keys(iconSet);
export type FillColour = 'default' | 'neutral' | 'primary' | 'secondary' | 'transparent';
export const FillColours: FillColour[] = ['default', 'neutral', 'primary', 'secondary', 'transparent'];
